module.exports = __webpack_public_path__ + "img/1sJhDRqFd_FmIIEH0Tsjd_nZxm1Uqj8g1.7321d2c2.png";